module.exports = __webpack_public_path__ + "img/instalacion_msh.b6b6210a.jpg";